import React, { useEffect } from "react";
import {
  EditSimpleWorkflowFieldDrawer,
  SimpleWorkflowFieldSaveData
} from "./EditSimpleWorkflowFieldDrawer";
import {
  EditGeneralWorkflowFieldDrawer,
  WorkflowFieldSaveData
} from "./EditGeneralWorkflowFieldDrawer";
import { APIFieldItem } from "@/pages/settings/types";
import { QuestionnaireType } from "@/components/controls/Questionnaires/Questionnaire";

interface EditWorkflowFieldDrawerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  fieldData: APIFieldItem | null;
  workflowType: QuestionnaireType;
  questionnaireId: string;
  enableAutofill?: boolean;
  onSave?: (fieldData: SimpleWorkflowFieldSaveData) => void | Promise<void>;
  onGeneralSave: () => void;
  // Required so a system-field rename can never fall back to an in-place edit.
  onSaveGeneralField: (
    fieldData: WorkflowFieldSaveData
  ) => void | Promise<void>;
  onDelete?: (fieldId: string) => void;
}

export const EditWorkflowFieldDrawer: React.FC<
  EditWorkflowFieldDrawerProps
> = ({
  isOpen,
  onOpenChange,
  fieldData,
  workflowType,
  questionnaireId,
  enableAutofill = true,
  onSave,
  onDelete,
  onGeneralSave,
  onSaveGeneralField
}) => {
  // The drawer is non-modal, so lock the settings page scroll while it's open
  // — otherwise the card behind scrolls alongside the drawer.
  useEffect(() => {
    if (!isOpen) return;
    const content = document.querySelector<HTMLElement>(
      '[data-test="settings-main-content"]'
    );
    if (!content) return;
    const previousOverflow = content.style.overflow;
    content.style.overflow = "hidden";
    return () => {
      content.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (
    workflowType === QuestionnaireType.GENERAL ||
    workflowType === QuestionnaireType.POC
  ) {
    return (
      <EditGeneralWorkflowFieldDrawer
        isOpen={isOpen}
        onSave={onGeneralSave}
        onSaveField={onSaveGeneralField}
        onOpenChange={onOpenChange}
        fieldData={fieldData}
        questionnaireId={questionnaireId}
        enableAutofill={enableAutofill}
        onDelete={onDelete}
      />
    );
  }

  return (
    <EditSimpleWorkflowFieldDrawer
      workflowType={workflowType}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      fieldData={fieldData}
      questionnaireId={questionnaireId}
      enableAutofill={enableAutofill}
      onSave={onSave}
      onDelete={onDelete}
    />
  );
};
